module.exports = __webpack_public_path__ + "media/hallBgm.e888c794.mp3";